var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3607_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8874 6.73042L20.4118 4.27545V0.68958C20.377 0.334365 20.1034 0.04926 19.7499 0H4.52374C4.17026 0.0493125 3.89655 0.334365 3.86171 0.68958V4.24789L0.24825 6.73039C0.105119 6.8343 0.0144663 6.99548 0 7.17169V20.2739C0.046989 20.6335 0.32998 20.9166 0.68958 20.9635H23.584C23.8874 20.9635 23.9977 20.6049 23.9977 20.2739V7.17172C23.9977 7.00624 24.0253 6.84071 23.8874 6.73042ZM20.4118 5.5995L22.7841 7.22685L20.4118 9.0198V5.5995ZM4.96508 1.10335H19.3085V9.87499L12.1368 15.2813L4.965 9.87499L4.96508 1.10335ZM3.86171 5.57194V9.04744L1.4895 7.22696L3.86171 5.57194ZM1.10335 8.35785L8.82679 14.2056L1.10335 19.4188V8.35785ZM2.42738 19.8602L9.76459 14.9227L11.7231 16.4122C11.8339 16.4979 11.9691 16.5463 12.1092 16.5502C12.2196 16.5502 12.2747 16.495 12.385 16.4122L14.4262 14.84L21.8462 19.8602H2.42738ZM22.8944 19.2258L15.3365 14.1504L22.8944 8.35785V19.2258Z",
    fill: "#F15A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72354 4.68928H10.206C10.5108 4.68928 10.7577 4.4423 10.7577 4.13761C10.7577 3.83293 10.5108 3.58594 10.206 3.58594H7.72354C7.41885 3.58594 7.17188 3.83293 7.17188 4.13761C7.17188 4.4423 7.41885 4.68928 7.72354 4.68928Z",
    fill: "#F15A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72354 7.17168H16.5503C16.855 7.17168 17.102 6.92471 17.102 6.62002C17.102 6.31533 16.855 6.06836 16.5503 6.06836H7.72354C7.41885 6.06836 7.17188 6.31533 7.17188 6.62002C7.17188 6.92471 7.41885 7.17168 7.72354 7.17168Z",
    fill: "#F15A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.102 9.10244C17.102 8.79776 16.855 8.55078 16.5503 8.55078H7.72354C7.41885 8.55078 7.17188 8.79776 7.17188 9.10244C7.17188 9.40713 7.41885 9.65414 7.72354 9.65414H16.5503C16.855 9.65414 17.102 9.40713 17.102 9.10244Z",
    fill: "#F15A24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3607_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAdd);
export default __webpack_public_path__ + "static/media/email_add.0d982258d23afacece37310b21031498.svg";
export { ForwardRef as ReactComponent };